import { CardContent, TextField } from '@material-ui/core';
import FancyCard from '../../../components/fancy/FancyCard';
import React from 'react';

function PaymentFormOnhouse({ note, setNote }) {
    return (
        <FancyCard fullWidth>
            <CardContent>
                <h3 className="mb-2">On house account booking</h3>
                <h5>
                    The payment doesn&apos;t require credit card, your company will be charged at
                    the end of the month.
                </h5>
                <TextField
                    fullWidth
                    label="Private agent notes (to identify the customer)"
                    name="note"
                    placeholder="Fill out with the required information, like room number, booking identifier, etc."
                    type="text"
                    value={note}
                    onChange={ev => {
                        setNote(ev.target.value);
                    }}
                />
            </CardContent>
        </FancyCard>
    );
}

export default PaymentFormOnhouse;
